import {
    StoredCardDTO
} from "@app/core/payment-method/application/stored-card-dto";
import {
    UsualConditionsDTO
} from "@app/core/payment-method/application/usual-conditions-dto";

interface PaymentMethodsParams {
    readonly cards: StoredCardDTO[] | null;
    readonly usualConditions: UsualConditionsDTO | null;
}


/**
 * Represents the payment methods the user has.
 */
export class PaymentMethodsDTO {
    readonly cards: StoredCardDTO[] | null;
    readonly usualConditions: UsualConditionsDTO | null;
    constructor(params: PaymentMethodsParams) {
        this.cards = params.cards;
        this.usualConditions = params.usualConditions;
    }
}